import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";

const LeadSources = () => {
    const [leadSources, setLeadSources] = useState([]);
    const { jwtToken } = useOutletContext();
    const navigate = useNavigate();

    useEffect(() => {
        if (jwtToken === "") {
            navigate("/login");
            return;
        }

        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + jwtToken);

        const requestOptions = {
            method: "GET",
            headers: headers,
        };
        fetch(`${process.env.REACT_APP_BACKEND}/api/sources`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setLeadSources(data.sources);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [jwtToken]);

    return (
        <div>
            <h2>Источники лидов</h2>
            <table className="table table-stripped table-hover">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>URL</th>
                        <th>Пользователь</th>
                    </tr>
                </thead>
                <tbody>
                    {leadSources.map((s) => (
                        <tr key={s.id}>
                            <td>{s.id}</td>
                            <td>
                                <Link to={`/sources/${s.id}`}>{s.name}</Link>
                            </td>
                            <td>
                                {s.user && (
                                    <Link to={`/users/${s.user.id}`}>
                                        {s.user.name}
                                    </Link>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default LeadSources;
